import { useTenantContext } from '../tenant-context/index.tsx';

type ActivationId = string;
export const useActivationId = (): ActivationId => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.activationId;
};
